export default __webpack_public_path__ + "images/08db920b4a51a003f583ac5010d6e6a8-after_school_care.webp";